
import { apigetAlertsData, apiGetAnalyticsDashboard, apiTicketDashboardData } from "services/DashboardsService";
import { apiDropdownBs, apiDropdownVarient, apiDtcDashboardData, apiGetDealerLocaton, apiGetSearchList, apiGetServiceDealerLocaton, apiGetVehicleDashboard, apigetSamrtFileredData } from "services/DTCService";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// export const getTicketsData = createAsyncThunk(
//     'dashboards/data/getTicketsData',
//     async (data) => {
//         const response = await apiTicketDashboardData(data)
//         return response
//     }
// )

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    sort: {
        Item: '',
        key: '',
    },
}

const dataSlice = createSlice({
    name: 'dailerApp/data',
    initialState: {
        loading: false,
        tableData: initialTableData,
    },
    reducers: {
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setLoading: (state, action) => {
            state.tableData = action.payload
        },
    },
    extraReducers: {
        // [getTicketsData.fulfilled]: (state, action) => {
        //     state.ticketsData = action.payload
        //     state.loading = false
        // },
        // [getTicketsData.pending]: (state, action) => {
        //     state.loading = true
        // },
    }
})

export const { setTableData, setLoading, setSelectedTab } = dataSlice.actions
export default dataSlice.reducer